import React from "react";

export default function Button(props){
    const numbers = {
        background: props.background,
        color: props.color,
        boxShadow : props.shadow
      }
    return<div 
    className = "numbers"
     style  = {numbers} 
     onClick = {props.onClick} 
     id = {props.name}>
         {props.name}
     </div>;
}